import { Component, OnInit } from '@angular/core';
import { AbstractFieldComponent } from '../../abstract/abstract-field.component';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {FormFieldService} from '../../../services/form-field.service';

@Component({
  selector: 'app-telephone-number-field',
  templateUrl: './telephone-number-field.component.html',
  styleUrls: ['./telephone-number-field.component.scss']
})
export class PhoneFieldComponent extends AbstractFieldComponent implements OnInit {

  placeholder: string;

  prefix: string = '48';
  number: string;

  fullNumber: string;

  // commented line is definition of original requirements for displaying verification hint
  get verificationHintVisible(): boolean {
    return false;
    // return this.isPredefinedValue && !this.errorsMap.get(this.fieldConfig.fieldKey);
  }

  public ngOnInit(): void {
    this.placeholder = this.fieldConfig.caption;
    this.initStartValues();
    this.handleStatusChanges();
  }

  constructor(public formFieldService: FormFieldService) {
    super(formFieldService);
  }

  numberChange(): void {
    this.concatPhoneNumber();
    this.changeControlValue();
    this.onChange(null);
  }

  prefixChange(): void {
    this.concatPhoneNumber();
    this.changeControlValue();
    this.onChange(null);
  }

  concatPhoneNumber(): void {
    if (isNotNullOrUndefined(this.number)) {
      this.fullNumber = this.prefix.concat(this.number);
    }
  }

  changeControlValue(): void {
    this.control.setValue(this.fullNumber);
  }

  initStartValues() {
    let value = this.control.value;

    if (value) {
      this.prefix = value.slice(0, 2);
      this.number = value.slice(2);
    }
  }

  clearField(): void {
    this.number = '';
    this.changeControlValue();
  }
}

